
import { ManualPart } from './types';
import { part1 } from './data/part1';
import { part2 } from './data/part2';
import { part5 } from './data/part5';
import { part6 } from './data/part6';
import { part7 } from './data/part7';

export const MANUAL_DATA: ManualPart[] = [
  part1,      // INTRODUCCIÓN Y HUB DE PROYECTOS
  part2,      // CONFIGURACIÓN DE PROYECTOS (Antiguos Part 2, Part 3 y secciones de Part 4)
  part5,      // REPORTES Y RESULTADOS DETALLADOS (Antiguas secciones de Part 4 y Part 5)
  part6,      // EXPORTACIÓN Y FLUJO FINAL
  part7       // GLOSARIO TÉCNICO Y FÓRMULAS
];
